// extracted by css-extract-rspack-plugin
export default {"fileField":"uiXl7bIRhMgCHVyr","uploadFileName":"_7_U1UtEUAI5Ni7u","buttonDelete":"wv0oSXIlsxI8Elxb"};